import { makeAutoObservable } from 'mobx';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {TimeTrackingPaySchedule} from 'main/stores/time_tracking';
import {DomainStore} from 'shared/store';
import _ from 'lodash';

class TimesheetsState {
  store = new DomainStore();
  interactiveAgent;

  paySchedules = [];
  selectedPaySchedule = {};
  selectedPayPeriod = {};
  timesheet;
  initialLoad = true;
  DROPDOWN_FILTER_OPTIONS = [
    {id: 'assigned_to_me', display: t('time_tracking.timesheets.Assigned to me')},
    {id: 'all', display: t('time_tracking.timesheets.All')}
  ];

  selectTimesheet = (timesheet) => {
    this.timesheet = timesheet;
    this.initialLoad = false;
  };

  constructor() {
    makeAutoObservable(this, {
      store: false,
      interactiveAgent: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.TIME_TRACKING.PAY_SCHEDULES.ALL
    ]);

    this.paySchedules = this.store._getAll(types.TIME_TRACKING.PAY_SCHEDULE, TimeTrackingPaySchedule);
    if (_.isEmpty(this.paySchedules)) {
      window.location = '/time_tracking';
    } else {
      this.selectPaySchedule(this.paySchedules[0]);
    }
  }

  setInteractiveAgent(agent) {
    this.interactiveAgent = agent;
  }

  selectPaySchedule(paySchedule) {
    this.selectedPaySchedule = paySchedule;
    this.selectPayPeriod(this.selectedPaySchedule.previousPayPeriod);
  }

  selectPayPeriod(payPeriod) {
    this.selectedPayPeriod = payPeriod;
  }
}

export default TimesheetsState;
